"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SessionStorage = void 0;
var _isSessionStorageSupported = require("../utils/isSessionStorageSupported");
var _singleton = require("../utils/singleton");
var _class;
var isSessionStorageAvailable = (0, _isSessionStorageSupported.isSessionStorageSupported)();
var SessionStorage = exports.SessionStorage = (0, _singleton.singleton)(_class = /*#__PURE__*/ function() {
    function SessionStorage() {
        _class_call_check(this, SessionStorage);
    }
    _create_class(SessionStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                if (!(key !== '' && isSessionStorageAvailable)) {
                    return null;
                }
                var value = sessionStorage.getItem(key);
                if (value === null) {
                    return null;
                }
                try {
                    return JSON.parse(value);
                } catch (error) {
                // NOOP
                }
                return value;
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                if (key !== '' && isSessionStorageAvailable) {
                    sessionStorage.setItem(key, JSON.stringify(value));
                }
                return this;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                if (key !== '' && isSessionStorageAvailable) {
                    sessionStorage.removeItem(key);
                }
                return this;
            }
        },
        {
            key: "clearItems",
            value: function clearItems(prefix) {
                if (prefix !== '' && isSessionStorageAvailable) {
                    Object.keys(sessionStorage).filter(function(keyName) {
                        return keyName.indexOf(prefix, 0) === 0;
                    }).forEach(function(key) {
                        return sessionStorage.removeItem(key);
                    });
                }
            }
        }
    ]);
    return SessionStorage;
}()) || _class; //# sourceMappingURL=SessionStorage.js.map
